import { URL_LANGUAGE } from "../../constants/inital-lang.c"
import { LANGUAGES } from "../../constants/languages.c"

export const isJapanese = ()=>{
    if (URL_LANGUAGE===LANGUAGES.JP){
        return true
    } else{
        return false
    }
}